import angular from 'angular';
import { UCtaCardComponent, UFaIconComponent } from '@updater/angular-common';
import { RentersInsuranceConfig } from './renters-insurance.config';
import { RentersInsuranceComponent } from './renters-insurance.component';
import { CardModule } from '../../core';
import {
  StepPageModule,
  UCloudinaryImageDirectives,
} from '../../common/directives';

export const RentersInsuranceStepModule = angular
  .module('app.steps.renters-insurance', [
    CardModule.name,
    StepPageModule.name,
    UCloudinaryImageDirectives.name,
    UCtaCardComponent.name,
    UFaIconComponent.name,
  ])
  .config(RentersInsuranceConfig)
  .component('updRentersInsurance', RentersInsuranceComponent);
